import produce from 'immer';

import {
  VIOLATION_DISPOSITION_EDIT_SEQUENCE_FAILURE,
  VIOLATION_DISPOSITION_EDIT_SEQUENCE_SUCCESS,
  VIOLATION_DISPOSITION_FETCH_FAILURE,
  VIOLATION_DISPOSITION_FETCH_REQUEST,
  VIOLATION_DISPOSITION_FETCH_SUCCESS,
  VIOLATION_DISPOSITIONS_FETCH_FAILURE,
  VIOLATION_DISPOSITIONS_FETCH_REQUEST,
  VIOLATION_DISPOSITIONS_FETCH_SUCCESS,
} from '@actions/violationDisposition';

const initialState: IViolationDispositionStore = {
  currentViolationDisposition: null,
  compliantDispositions: null,
  invalidDispositions: null,
  error: null,
};

const getViolationDispositions = (
  dispositions: IConfigViolationDispositionResponse[],
  dispositionType: DispositionType
): IConfigViolationDispositionResponse[] =>
  dispositions
    .filter((disposition) => disposition.dispositionType === dispositionType)
    .sort((a, b) => a.sequence - b.sequence);

export default (state: IViolationDispositionStore = initialState, action: any) =>
  produce(state, (draftState: IViolationDispositionStore) => {
    switch (action.type) {
      case VIOLATION_DISPOSITIONS_FETCH_REQUEST:
        draftState.compliantDispositions = null;
        draftState.invalidDispositions = null;
        draftState.error = null;

        return;

      case VIOLATION_DISPOSITIONS_FETCH_SUCCESS:
      case VIOLATION_DISPOSITION_EDIT_SEQUENCE_SUCCESS:
        draftState.compliantDispositions = getViolationDispositions(action.response, DispositionType.COMPLIANT);
        draftState.invalidDispositions = getViolationDispositions(action.response, DispositionType.INVALID);
        draftState.error = null;

        return;

      case VIOLATION_DISPOSITION_EDIT_SEQUENCE_FAILURE:
        draftState.error = action.error;

        return;

      case VIOLATION_DISPOSITIONS_FETCH_FAILURE:
        draftState.compliantDispositions = null;
        draftState.invalidDispositions = null;
        draftState.error = action.error;

        return;

      case VIOLATION_DISPOSITION_FETCH_REQUEST:
        draftState.currentViolationDisposition = null;
        draftState.error = null;

        return;

      case VIOLATION_DISPOSITION_FETCH_SUCCESS:
        draftState.currentViolationDisposition = action.response;
        draftState.error = null;

        return;

      case VIOLATION_DISPOSITION_FETCH_FAILURE:
        draftState.currentViolationDisposition = null;
        draftState.error = action.error;

        return;
    }
  });
